/** Measure immediately; older TV engines can still follow window/fullscreen resizes. */
export function observeResize(element: Element, update: () => void) {
  update();
  const observer = typeof ResizeObserver === 'function' ? new ResizeObserver(update) : null;
  observer?.observe(element);
  window.addEventListener('resize', update);
  document.addEventListener('fullscreenchange', update);
  return () => {
    observer?.disconnect();
    window.removeEventListener('resize', update);
    document.removeEventListener('fullscreenchange', update);
  };
}
